export interface Vector3 {
  x: number;
  y: number;
  z: number;
}

export function clamp(value: number, minimum: number, maximum: number): number {
  return Math.min(maximum, Math.max(minimum, value));
}

export function clamp01(value: number): number {
  return clamp(value, 0, 1);
}

export function lerp(from: number, to: number, alpha: number): number {
  return from + (to - from) * alpha;
}

export function lerpVector3(
  from: Readonly<Vector3>,
  to: Readonly<Vector3>,
  alpha: number,
): Vector3 {
  return {
    x: lerp(from.x, to.x, alpha),
    y: lerp(from.y, to.y, alpha),
    z: lerp(from.z, to.z, alpha),
  };
}

export function wrapRadians(angle: number): number {
  const fullTurn = Math.PI * 2;
  return ((angle + Math.PI) % fullTurn + fullTurn) % fullTurn - Math.PI;
}

export function lerpRadians(from: number, to: number, alpha: number): number {
  return wrapRadians(from + wrapRadians(to - from) * alpha);
}

export function normalizePlanar(
  x: number,
  z: number,
): Readonly<{ x: number; z: number }> {
  const length = Math.hypot(x, z);
  if (length <= Number.EPSILON) {
    return { x: 0, z: 0 };
  }

  return { x: x / length, z: z / length };
}
